import { useEffect, useState } from "react";
import { CalendarPlus, Copy, ArrowsClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const CalendarSubscribe = ({ mobile = false }) => {
  const [token, setToken] = useState("");

  useEffect(() => {
    api
      .get("/me/calendar")
      .then(({ data }) => setToken(data.token))
      .catch(() => {});
  }, []);

  const url = token ? `${BASE}/api/public/calendar/${token}.ics` : "";
  const gcal = url
    ? `https://calendar.google.com/calendar/u/0/r/settings/addbyurl?url=${encodeURIComponent(url)}`
    : "";

  const copy = () => {
    navigator.clipboard?.writeText(url);
    toast.success("Calendar link copied");
  };
  const rotate = async () => {
    try {
      const { data } = await api.post("/me/calendar/rotate");
      setToken(data.token);
      toast.success("Old link disabled — new link ready");
    } catch {
      toast.error("Could not reset the link");
    }
  };

  return (
    <div
      className={`mt-4 border p-4 ${
        mobile
          ? "rounded-2xl border-slate-800 bg-[#0F172A]"
          : "rounded-lg border-zinc-800 bg-zinc-900"
      }`}
      data-testid="calendar-subscribe"
    >
      <div
        className={`flex items-center gap-2 text-xs font-bold uppercase tracking-widest ${
          mobile ? "text-[#c39e6d]" : "text-zinc-400"
        }`}
      >
        <CalendarPlus size={15} weight="bold" /> Subscribe to your schedule
      </div>
      <p className="mt-1 text-xs text-zinc-500">
        Add your Template / Fabrication / Install stops and tasks to Google,
        Apple or Outlook. It stays in sync automatically — no re-importing.
      </p>
      <div className="mt-3 flex items-center gap-2">
        <input
          readOnly
          value={url}
          data-testid="calendar-url"
          onFocus={(e) => e.target.select()}
          className="h-10 min-w-0 flex-1 rounded-lg border border-zinc-800 bg-zinc-950 px-3 font-mono-data text-xs text-zinc-300"
        />
        <button
          type="button"
          data-testid="calendar-copy"
          onClick={copy}
          className={`flex h-10 shrink-0 items-center gap-1 rounded-lg border px-3 text-xs font-semibold transition-colors duration-150 ${
            mobile
              ? "border-[#c39e6d]/40 text-[#c39e6d] hover:bg-[#c39e6d]/10"
              : "border-zinc-700 text-zinc-300 hover:bg-zinc-800"
          }`}
        >
          <Copy size={14} weight="bold" /> Copy
        </button>
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        <a
          href={gcal}
          target="_blank"
          rel="noreferrer"
          data-testid="calendar-google"
          className="rounded-lg border border-zinc-700 px-3 py-2 text-[11px] font-semibold uppercase tracking-widest text-zinc-300 transition-colors duration-150 hover:bg-zinc-800"
        >
          Add to Google
        </a>
        <a
          href={url}
          data-testid="calendar-download"
          className="rounded-lg border border-zinc-700 px-3 py-2 text-[11px] font-semibold uppercase tracking-widest text-zinc-300 transition-colors duration-150 hover:bg-zinc-800"
        >
          Apple / Outlook (.ics)
        </a>
        <button
          type="button"
          data-testid="calendar-rotate"
          onClick={rotate}
          className="ml-auto inline-flex items-center gap-1 rounded-lg border border-zinc-800 px-3 py-2 text-[11px] font-semibold uppercase tracking-widest text-zinc-500 transition-colors duration-150 hover:text-red-300"
        >
          <ArrowsClockwise size={13} weight="bold" /> Reset link
        </button>
      </div>
    </div>
  );
};
